module.exports = "/assets/js/07724bfd7411987b7cb0a3e00cf24a66.svg";